var M, T, creator, fail, luDecompConstructor, luDecompPrototype;

M = require("./matrix");

creator = require("ut1l/create/object");

T = require("ut1l/create/throwable");

fail = T("MatrixException");


/*
  A very basic LU decomposition implementation without pivoting. Decomposition is done in place. Given buffer must
  be square and regular. The values of L below the diagonal are stored. The ones on the diagonal and the zeros
  above the diagonal are not stored. The values of U on and above the diagonal are stored. The zero values below
  the diagonal are not stored.
 */

luDecompConstructor = function(A, T) {
  var i, j, k, _i, _j, _k, _l, _m, _ref, _ref1, _ref2, _ref3;
  if (T == null) {
    T = A.clone();
  }
  for (i = _i = 0, _ref = T.columns; _i < _ref; i = _i += 1) {
    for (j = _j = i, _ref1 = T.columns; _j < _ref1; j = _j += 1) {
      for (k = _k = 0; _k < i; k = _k += 1) {
        T.set(i, j, (T.get(i, j)) - (T.get(i, k)) * (T.get(k, j)));
      }
    }
    for (j = _l = _ref2 = i + 1, _ref3 = T.columns; _l < _ref3; j = _l += 1) {
      for (k = _m = 0; _m < i; k = _m += 1) {
        T.set(j, i, (T.get(j, i)) - (T.get(j, k)) * (T.get(k, i)));
      }
      T.set(j, i, (T.get(j, i)) / (T.get(i, i)));
    }
  }
  this.lu = T;
};

luDecompPrototype = {

  /* Calculate X = A^-1 * B in place or not in place */
  solve: function(B, T) {
    var A, i, j, k, _i, _j, _k, _l, _m, _n, _o, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
    if (T == null) {
      T = B.clone();
    }
    A = this.lu;
    if (B.rows !== A.columns || !B.isSize(T)) {
      fail("unmatching matrix dimension");
    }
    for (k = _i = 0, _ref = A.columns; _i < _ref; k = _i += 1) {
      for (i = _j = _ref1 = k + 1, _ref2 = A.columns; _j < _ref2; i = _j += 1) {
        for (j = _k = 0, _ref3 = T.columns; _k < _ref3; j = _k += 1) {
          T.set(i, j, (T.get(i, j)) - (T.get(k, j)) * (A.get(i, k)));
        }
      }
    }
    for (k = _l = _ref4 = A.columns - 1; _l >= 0; k = _l += -1) {
      for (j = _m = 0, _ref5 = T.columns; _m < _ref5; j = _m += 1) {
        T.set(k, j, (T.get(k, j)) / (A.get(k, k)));
      }
      for (i = _n = 0; _n < k; i = _n += 1) {
        for (j = _o = 0, _ref6 = T.columns; _o < _ref6; j = _o += 1) {
          T.set(i, j, (T.get(i, j)) - (T.get(k, j)) * (A.get(i, k)));
        }
      }
    }
    return T;
  },
  getInverse: function() {
    var I;
    I = M.I(this.lu.columns);
    return this.solve(I, I);
  }
};

module.exports = creator(luDecompConstructor, luDecompPrototype);
